import '../../styles/textStyle.css';
import './TitleBar.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var navigationWrapperCSS = '_wcwjv22-3-5-0';
export var subtitleCSS = '_wcwjv23-3-5-0 _da9a8v0-3-5-0 _da9a8v2-3-5-0 _da9a8v3-3-5-0 _da9a8vb-3-5-0';
export var suffixWrapperCSS = '_wcwjv24-3-5-0';
export var titleSubtitleWrapperCSS = _7a468({defaultClassName:'_wcwjv20-3-5-0',variantClassNames:{childrenAreText:{true:'_wcwjv21-3-5-0'}},defaultVariants:{},compoundVariants:[]});